<template>
  <div>
    <h2>{{ title }}</h2>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <input-search />
        <circle-button @click.native="createMiniTCDC" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>{{ item.branch ? item.branch.branch_name_th : "" }}</td>
              <td>{{ item.zone }}</td>
              <td>{{ item.branch_name_th }}</td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>{{ item.orders }}</td>
              <td>
                <a @click="showMiniTCDC(item.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import IconPencil from "../../../components/Icon/icon-pencil";
import InputTextField from "../../../components/Input/InputTextField";
import CircleButton from "../../../components/Button/CircleButton";
import InputSearch from "../../../components/Input/InputSearch";
import Paginate from "../../../components/Layout/Paginate";
export default {
  name: "MiniBranch",
  components: {Paginate, InputSearch, CircleButton, InputTextField, IconPencil },
  data() {
    return {
      title: "Mini TCDC",
      headers: [
        { id: 1, text: "No." },
        { id: 2, text: "Branch" },
        { id: 3, text: "Zone" },
        { id: 4, text: "Mini TCDC" },
        { id: 5, text: "Update date" },
        { id: 6, text: "Order" },
        { id: 7, text: "edit" }
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      }
    };
  },
  created() {
    this.getMiniTCDCTable(1);
  },
  methods: {
    goToMiniBranchEdit() {
      this.$router.push("/mini-tcdc/edit");
    },
    getMiniTCDCTable(page) {
      this.$store.dispatch("TCDCMini/getTCDCMini", page).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    },
    showMiniTCDC(id) {
      this.$store.dispatch("TCDCMini/showTCDCMini", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("TCDCMini/setFormTCDCMini", res.result).then(() => {
            this.goToMiniBranchEdit();
          });
        } else {
          alert(res.response_msg);
        }
      });
    },
    createMiniTCDC() {
      this.$store.dispatch("TCDCMini/clearFormData").then(() => {
        this.goToMiniBranchEdit();
      });
    },
    changePage(val){
      this.dataPaginate.current_page = val;
      this.$store.dispatch("TCDCMini/getTCDCMini", this.dataPaginate.current_page).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/table.css";
.branch-data {
  background-color: transparent;
  margin: 20px;
}
.theme--light.v-system-bar {
  background-color: transparent !important;
  color: rgba(0, 0, 0, 0.6);
}
</style>
